<dx-popup
  [visible]="showModal"
  [title]="'PUBLISHING-MODE.DEACTIVATE-PUBLISHING-MODE.TITLE' | translate"
  [width]="450"
  height="auto"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [showCloseButton]="false"
  (onHidden)="cancel()"
>
  <div>
    <p>{{ 'PUBLISHING-MODE.DEACTIVATE-PUBLISHING-MODE.TEXT' | translate }}</p>
    <div class="action-container">
      <dx-button 
        [text]="'COMMON.CANCEL' | translate" 
        type="normal"
        stylingMode="contained"
        (onClick)="cancel()"
      ></dx-button>
      <dx-button 
        [text]="'COMMON.DEACTIVATE' | translate" 
        type="danger"
        stylingMode="contained"
        (onClick)="deactivate()"
      ></dx-button>
    </div>
  </div>
</dx-popup>